import OverallSectionSummaryTable from "pages/PanelPage/components/selectedAssessment/assessmentResults/takerResults/OverallSectionSummaryTable/OverallSectionSummaryTable";

export default OverallSectionSummaryTable;
